module.exports = __webpack_public_path__ + "static/img/partner4_1.127f50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner4_1.png
// module id = 2P65
// module chunks = 1